module.exports = __webpack_public_path__ + "static/media/success.63f39bfc.svg";